import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModelService } from './model.service';


@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  default:   any;
  alloweds:  any = ['pt', 'es', 'en'];
  phrase:    any;

  constructor(
    private translateService: TranslateService,
    private modelService: ModelService,

  ) { }

  async initialize(language ?: any | string) {
    // checar no storage
    this.default = (language != null) ? language : await this.modelService.getRoot('language');
    
    if(this.default == null) {
      
      this.default = this.translateService.getBrowserLang();
      await this.modelService.setRoot('language', this.default); 
    }


    // Usar fallback pra portugues caso não encontre a traudução
    this.translateService.setDefaultLang('en'); // vou deixar como ingles durante o desenvolvimento, pra ver que n tem chave nessa bosta

    // Caso default permaneça a null, setar como português
    // this.default = (this.default == null) ? this.translateService.setDefaultLang('pt') : this.default;

    // Setar como inglês caso o idioma não esteja dentre os permitidos
    this.default = (this.alloweds.indexOf(this.default) > -1) ? this.default : 'en';
    
    this.translateService.use(this.default);

    // Instanciar o getAll para traduçÕes via atribute data-jsmx-getPhrase
    await this.getAll();

    return this.default;
  }

  /**  
   * Recebe um valor em string ou input em html, pega o valor e seta no storage
   * 
   * @param <string | any> valueOrInput
   * @return <void>
  **/
  async set(valueOrInput: any | string) {
     
    valueOrInput = (typeof(valueOrInput) == 'string') ? valueOrInput : valueOrInput.target.value;
 
     await this.modelService.setRoot('language', valueOrInput);
     await this.initialize();
  }

  async check() {
    this.default = await this.modelService.getRoot('language') || await this.initialize();

    // Marcar o select do modal language, caso o modal esteja disponível
    // if(checkboxLanguage == true) document.querySelector('ion-radio-group').value = this.default;

    return this.default; 

  }

  /**  
   * Recebe um valor em string ou input em html, pega o valor e seta no storage
   * 
   * @param <string|any> valueOrInput
   * @return <string | HtmlElement> phrase
  **/
  get(phrase: string, params ?: any): Promise<any> {
    
    const translate = this.translateService.get(phrase, params).subscribe((response: string) => {
    
      this.phrase = response;
   
    });

    translate.unsubscribe();
    return this.phrase;
  }

  /**  
   * Insere dentro de um element Html o texto traduzio + elemento html
   * 
   * @return <string | HtmlElement>
  **/
  async getAll() {    
    const phrases = document.querySelectorAll('[data-jsmx-getPhrase]');
    
    phrases.forEach((phraseContainer) => {
      const phrase = phraseContainer.getAttribute('data-jsmx-getPhrase').toUpperCase();
    
      this.translateService.get(phrase).subscribe((response: string) => {
        phraseContainer.innerHTML = response;
      });
    });
      
  }
}
